module.exports = __webpack_public_path__ + "img/Free Response 05.af322f95.png";